export default __webpack_public_path__ + "static/media/Web_App.6d3e76aa.webp";